// extracted by mini-css-extract-plugin
module.exports = {"ringLoader":"LoadingElement_ringLoader__gj9k1","loadingText":"LoadingElement_loadingText__qm8VO"};